import { FC } from 'react';

import { WorkflowStepFormFieldSelect } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const GenderFieldToBlock: FieldToBlock<
  'gender',
  WorkflowStepFormFieldSelect
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentProps: {
    options: field.options,
    size: 'sm',
  },
  componentType: 'select',
});

type GenderFieldValueProps = FieldValueProps<'gender'>;

export const GenderFieldValue: FC<GenderFieldValueProps> = ({ field }) => {
  const option = field.options.find((o) => o.value === field.value);

  return <>{((option && option.label) || field.value) ?? '–'}</>;
};
